export default __webpack_public_path__ + "static/media/hangarJetMobile.c8d747c2.jpg";